import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import localeEn from "@angular/common/locales/en-GB";
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, provideLuxonDateAdapter } from "@angular/material-luxon-adapter";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";

import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { getKeycloakConfig } from "@config/keycloak/keycloak.config";
import { TranslateProvider } from "@config/locales/translate.config";
import { CustomLuxonAdapter } from "@config/luxon/custom-luxon-adapter";
import { AuthInterceptor } from "@lib/auth/interceptors/auth.interceptor";
import { AuthService } from "@lib/auth/interfaces/IAuthService";
import { KeycloakAuthService } from "@lib/auth/services/keycloak-auth.service";
import { APP_ROUTES } from "@pages/app.routes";
import { provideKeycloak } from "keycloak-angular";
import { apolloProvider } from "./apollo/apollo.config";
import { localesProvider } from "./locales/locales.config";
import { Chart, registerables } from "chart.js";
import { cellDisplaySettingsProvider } from "@config/table/display.config";

registerLocaleData(localeEn);
Chart.register(...registerables);

export const APP_CONFIG: ApplicationConfig = {
    providers: [
        provideHttpClient(withFetch()),
        importProvidersFrom(
            TranslateProvider,
        ),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(APP_ROUTES),
        provideAnimationsAsync(),
        provideLuxonDateAdapter(),
        apolloProvider,
        localesProvider,
        {
            provide: LOCALE_ID,
            useValue: "en-GB",
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: "en-GB",
        },
        {
            provide: DateAdapter,
            useClass: CustomLuxonAdapter,
            deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideKeycloak(getKeycloakConfig()),
        { provide: AuthService, useClass: KeycloakAuthService },
        cellDisplaySettingsProvider,
    ],
};
